import { State } from 'modules';

export const notificationItems = (state: State) => state.notifications.items;
